// Sends designer events to the Google Analytics already running on the storefront (gtag or a
// dataLayer). Nothing is loaded here: with no analytics on the page, as in local development,
// these calls do nothing.

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export type DesignerEvent =
  | 'designer_route_added' // a route was uploaded or imported: the customer has started a design
  | 'designer_preview'
  | 'designer_saved'
  | 'designer_add_to_cart';

export function track(event: DesignerEvent, params: Record<string, string | number | boolean> = {}) {
  try {
    if (typeof window.gtag === 'function') window.gtag('event', event, params);
    else if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event, ...params });
  } catch {
    // Analytics must never interfere with designing or ordering.
  }
}
